import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatBadgeModule } from '@angular/material/badge';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { AlertComponent } from './alert/alert.component';
import { AlertService } from './alert/alert.service';
import { CurrencyDirective } from './directives/currency.directive';
import { PercentageDirective } from './directives/percentage.directive';
import { CurrencyPipe } from './pipes/currency.pipe';
import { PercentagePipe } from './pipes/percentage.pipe';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';



@NgModule({
  declarations: [
    HeaderComponent,
    SidenavComponent,
    FooterComponent,
    AlertComponent,
    CurrencyDirective,
    PercentageDirective,
  ],
  imports: [
    CommonModule,
    RouterModule,

    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatCardModule,
    MatBadgeModule,
    MatAccordion, 
    MatExpansionModule,
    MatProgressSpinnerModule,
    
    CurrencyPipe,
    PercentagePipe,
    BreadcrumbComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SidenavComponent,
    AlertComponent,
    CurrencyDirective,
    PercentageDirective,
    CurrencyPipe,
    PercentagePipe
  ],
  providers: [
    AlertService,
    CurrencyPipe,
    PercentagePipe
  ]
})
export class SharedModule { }
